import React from 'react';
import Input from '../../components/controls/Input';
import Select from '../../components/controls/Select';
import {FormHelperText} from '@mui/material';
import * as PREDEFINED_VALUES from '../../const/consts';
import JsonTextarea from '../../components/controls/JsonTextarea';

const FEConfigOptional = (props) => {
    const {options, setOptions, index, errors = {}} = props;

    const handleOptionalInputChange = (key, e) => {
        const option = options[key];
        const {name, value} = e.target
        const tmp = {
            ...option,
            [name]: value
        };
        let newOptions = [...options];
        newOptions[index] = tmp;
        setOptions(newOptions);
    }

    const handleOptionalJSONInputChange = (key, input) => {
        let newOptions = [...options];
        newOptions[key] = {
            ...newOptions[key],
            configJson: input
        };
        setOptions(newOptions);
    }

    return (
        <React.Fragment>
            <Select
                label="Platform"
                name="platform"
                defValue={options[index].platform}
                options={PREDEFINED_VALUES.mobile_platforms}
                onChange={(e) => {
                    handleOptionalInputChange(index, e)
                }}
            />
            {errors.items ? <FormHelperText sx={{marginLeft: 1.5}} error>{errors.items}</FormHelperText> : null}
            <Input
                label="SDK version"
                name="sdkVersion"
                value={options[index].sdkVersion}
                onChange={(e) => {
                    handleOptionalInputChange(index, e)
                }}
                error={errors.items}
            />
            <Input
                label="Platform version"
                name="platformVersion"
                value={options[index].platformVersion}
                onChange={(e) => {
                    handleOptionalInputChange(index, e)
                }}
                error={errors.items}
            />
            <p></p>
            <JsonTextarea
                placeholder={"Optional JSON"}
                value={options[index].configJson}
                onChange={(input) => {
                    handleOptionalJSONInputChange(index, input);
                }}
                error={errors[`items[${index}].configJson`]}
            />

        </React.Fragment>
    );

}

export default FEConfigOptional;
